import { 
  Box, 
  Button, 
  VStack, 
  Text, 
  FormControl, 
  FormLabel, 
  Input,
  FormErrorMessage,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useAddLocation } from "../../services/configurationService";
import { FiMapPin } from "react-icons/fi";

const AddLocation = ({ closeModal, editLocation, todo, editLocationPayload, editLocationIsLoading, refetchGetLocations }) => {
  const [inputData, setInputData] = useState({ address: "" });
  const [errors, setErrors] = useState({});
  
  const { addLocationIsLoading, addLocationPayload } = useAddLocation((res) => {
    refetchGetLocations();
    closeModal();
  });

  const validateForm = () => {
    const newErrors = {};
    if (!inputData.address.trim()) {
      newErrors.address = "Location address is required";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    const payload = {
      id: todo === "edit" ? editLocation?.id : "",
      address: inputData.address.trim(),
    };

    if (todo === "new") {
      addLocationPayload(payload);
    } else {
      editLocationPayload(payload);
    }
  };

  useEffect(() => {
    if (editLocation?.address) {
      setInputData({ address: editLocation.address });
    }
  }, [editLocation]);

  return (
    <Box>
      <form onSubmit={handleSubmit}>
        <VStack spacing={6} align="stretch">
          {/* Header */}
          <VStack spacing={2} align="center">
            <Box
              p={3}
              borderRadius="12px"
              bg="blue.50"
              color="blue.600"
              border="1px solid"
              borderColor="blue.200"
            >
              <FiMapPin size={24} />
            </Box>
            <VStack spacing={1}>
              <Text fontSize="lg" fontWeight="600" color="gray.900">
                {todo === "edit" ? "Edit" : "Add"} Location
              </Text>
              <Text fontSize="sm" color="gray.500" textAlign="center">
                {todo === "edit" ? "Update location information" : "Enter location details"}
              </Text>
            </VStack>
          </VStack>

          {/* Form Fields */}
          <FormControl isInvalid={!!errors.address}>
            <FormLabel fontSize="sm" fontWeight="500" color="gray.700">
              Location Address
            </FormLabel>
            <Input
              placeholder="Enter location address"
              value={inputData.address}
              onChange={(e) => setInputData({ ...inputData, address: e.target.value })}
              borderRadius="12px"
              borderColor="gray.200"
              _focus={{ borderColor: "blue.500", boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)" }}
              _hover={{ borderColor: "gray.300" }}
              size="lg"
            />
            <FormErrorMessage>{errors.address}</FormErrorMessage>
          </FormControl>

          {/* Submit Button */}
          <Button
            type="submit"
            colorScheme="blue"
            size="lg"
            borderRadius="12px"
            fontWeight="600"
            isLoading={addLocationIsLoading || editLocationIsLoading}
            loadingText={todo === "edit" ? "Updating..." : "Adding..."}
            _hover={{ transform: "translateY(-1px)", boxShadow: "lg" }}
            transition="all 0.2s"
          >
            {todo === "edit" ? "Update Location" : "Add Location"}
          </Button>
        </VStack>
      </form>
    </Box>
  );
};

export default AddLocation;
